// @flow

import { graphql } from 'react-relay';
import { ROOT_ID } from 'relay-runtime';
import createRelayMutation from 'shared/gql/createRelayMutation';

const mutation = graphql`
  mutation DeleteGLAccountMutation($input: DeleteGLAccountInput!) {
    deleteGLAccount(input: $input) {
      deletedId
    }
  }
`;

export default {
  commit: (options: Object) => {
    return createRelayMutation(mutation, {
      ...options,
      configs: [
        {
          type: 'RANGE_DELETE',
          parentID: ROOT_ID,
          connectionKeys: [
            { key: 'PaginatedGLAccountsContainer_glAccounts' },
          ],
          pathToConnection: [ROOT_ID, 'glAccounts'],
          deletedIDFieldName: 'deletedId',
        },
      ],
    });
  },
};
